import CustomHookFactory from "./CustomHookFactory";

export default CustomHookFactory("Modal", {
  isOpen: false,
  title: "",
  content: null,
  backdropReason: null,
  maxWidth: "sm",
});
